import Axios from 'axios';

const APP_API = 'https://api.forum.blockchainstudios.stream' || process.env.REACT_APP_API

export const request = Axios.create({
  baseURL: `${APP_API!}/api`,
  withCredentials: true,
});
